// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VvTe","controls":"styles_controls__2q8aG","charLimit":"styles_charLimit__24nxx","input":"styles_input__3U10N","send":"styles_send__26oMO"};